import script from "./MostrarMensaje.vue?vue&type=script&setup=true&lang=js"
export * from "./MostrarMensaje.vue?vue&type=script&setup=true&lang=js"

import "./MostrarMensaje.vue?vue&type=style&index=0&id=075f0896&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-075f0896"]])

export default __exports__